/** startswith prefix for DomainFromIp drilldown from aggregated subnet key. */
export const referringIpDrilldownPrefix = subnet => {
  if (!subnet) return '';
  const value = String(subnet);
  if (value.endsWith('.*.*')) {
    return value.replace(/\.\*\.\*$/, '.');
  }
  return value.replace(/\.\*$/, '.');
};

export const VALID_REFERRING_IP_PREFIX_LENGTHS = new Set([16, 24]);

export const normalizeReferringIpPrefixLength = raw => {
  const n = Number(raw);
  return VALID_REFERRING_IP_PREFIX_LENGTHS.has(n) ? n : 24;
};
